
import { Component, Vue, Prop, Mixins, Watch } from 'vue-property-decorator';
import CustomTagMixin from '@/@next/mixins/CustomTag';
import { CLazyLoadingImage } from '@/components/images';
import { CLoader } from '@/components/loader';
import CModal from '@/components/modal';
import { CImage } from '@/@next/components/image';
import { CButton } from '@/components/form-controls/button';
import _shuffle from 'lodash/shuffle';
import _cloneDeep from 'lodash/cloneDeep';
import Medias from '@/@next/services/Medias';
import { messages } from '@/@next/i18n';
import { TimelineContentData, TimelineContentEventData } from '@/@types/graphql';
import CTimelineContentEvent from './TimelineContentEvent.vue'
import CTimelineFullScreen from './TimelineFullScreen.vue'

const config = {
  name: 'c-content-timeline',
  i18n: { messages },
  components: {
    CLazyLoadingImage,
    CLoader,
    CImage,
    ...CModal,
    CButton,
    CTimelineContentEvent,
    CTimelineFullScreen
  }
};

@Component(config)
export default class CContentTimeline extends Mixins(CustomTagMixin, Medias) {
  @Prop({ type: Object, required: true }) content!: any;
  @Prop({ type: String, required: false, default: '' }) contextId!: string;

  showDescription: boolean = false;
  showTimeLineFullScreen: boolean = false;
  currentEventSelected: number = 0;
  shuffledEvents: TimelineContentEventData[] = []
  suffleTimer: any = null;
  gameIsCompleted: boolean = false

  @Watch('currentEventSelected')
  onCurrentIndexChanged () {
    const container = document.getElementById('timeline-events');
    if (!container) return
    const item = document.getElementById(`event-${this.currentEventSelected}`);
    if (!item) return
    const containerWidth = container.offsetWidth;
    const itemWidth = item.offsetWidth;
    const itemOffsetLeft = item.offsetLeft;
    const scrollLeft = itemOffsetLeft - (containerWidth - itemWidth) / 2;
    container.scrollLeft = scrollLeft;
  }

  get timeline (): TimelineContentData {
    return this.content.data
  }

  get title () {
    return (
      this.timeline?.i18n?.title?.value || {
        text: 'Timeline',
        html: 'Timeline'
      }
    );
  }

  get text () {
    return this.timeline?.i18n?.text?.value || null;
  }

  get events () {
    return this.displayAsGame ? this.shuffledEvents :  this.timeline?.events || [];
  }

  get classes () {
    return {
      'vertical': this.displayTimelineVertically && !this.displayAsGame
    }
  }

  get displayTimelineVertically () {
    return this.timeline.options?.displayTimelineVertically
  }

  selectEvent (i: number) {
    this.currentEventSelected = i;
    this.showTimeLineFullScreen = true;
  }

  endGame () {
    this.gameIsCompleted = true
    Vue.nextTick(() => { if (!this.displayAsGame) clearInterval(this.suffleTimer) })
  }

  shuffleEvents () {
    const images = _shuffle(_cloneDeep(this.timeline.events.map((e: TimelineContentEventData) => e.image)))
    this.shuffledEvents = this.timeline.events.map((e: TimelineContentEventData, i: number) => {
      return {
        ...e,
        image: images[i]
      }
    }).splice(0, 3)
  }

  get isGame () {
    return this.timeline.options.isGame
  }

  get isPlayed () {
    // TODO: FIND this value in cookies
    return this.gameIsCompleted;
  }

  get displayAsGame () {
    return this.isGame && !(this.timeline.options.gameToContent && this.isPlayed)
  }

  get hasInstruction () {
    return this.timeline.options.isGame
          && this.timeline.i18n.instruction
          && this.timeline.i18n.instruction.value.text.length > 1
  }

  get instruction () {
    return this.timeline.i18n.instruction?.value.html
  }

  mounted () {
    if (this.displayAsGame) {
      this.shuffleEvents()
      this.suffleTimer = setInterval(() => {
        this.shuffleEvents()
      }, 750);
    }
  }

  beforeDestroy () {
   clearInterval(this.suffleTimer);
  }

}
